import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';

export default function PrivacyPage() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Privacy Policy"
        description="Read DreamableAI's Privacy Policy. Learn how we collect, use, and protect your personal information when using our AI greeting card platform."
        path="/privacy"
      />
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="text-center mb-8">
              <Link to="/" className="text-3xl font-bold text-purple-600 hover:text-purple-700 transition">
                🎨 DreamableAI
              </Link>
              <h1 className="mt-4 text-3xl font-bold text-gray-900">Privacy Policy</h1>
              <p className="mt-2 text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
            </div>

          <div className="prose max-w-none">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Information We Collect</h2>
            <p className="mb-6 text-gray-700">
              We collect information you provide directly to us, such as when you create an account, use our services, or contact us for support.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. How We Use Your Information</h2>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>To provide and maintain our service</li>
              <li>To process your transactions</li>
              <li>To send you technical notices and support messages</li>
              <li>To improve our services</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Information Sharing</h2>
            <p className="mb-6 text-gray-700">
              We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Data Security</h2>
            <p className="mb-6 text-gray-700">
              We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Cookies and Tracking</h2>
            <p className="mb-6 text-gray-700">
              We use cookies and similar tracking technologies to enhance your experience and analyze usage patterns on our service.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Third-Party Services</h2>
            <p className="mb-6 text-gray-700">
              Our service may contain links to third-party websites or services. We are not responsible for the privacy practices of these third parties.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Your Rights</h2>
            <p className="mb-6 text-gray-700">
              You have the right to access, update, or delete your personal information. You can manage your account settings or contact us for assistance.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Changes to This Policy</h2>
            <p className="mb-6 text-gray-700">
              We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Contact Us</h2>
            <p className="mb-6 text-gray-700">
              If you have any questions about this Privacy Policy, please{' '}
              <Link to="/help" className="text-purple-600 hover:text-purple-500">contact our support team</Link>.
            </p>
          </div>

          <div className="mt-8 text-center">
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 transition"
              >
                ← Back to DreamableAI
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
} 